/**
 * 폼 데이터를 받아서 가공하여 서비스 데이터로 토스해준다.
 */
export class GetStoreBaromoney {
    /** 기간 타입 */
    dateType = 'daily';
    /** 선택한 허브 아이디 */
    selectedHubId = '';
    /** 선택한 상점 아이디 */
    selectedStoreId = '';
    /** 기간 */
    date = [];
    constructor(formData) {
        Object.assign(this, {
            selectedHubId: formData.selectedHubId,
            selectedStoreId: formData.selectedStoreId,
            date: formData.date,
            dateType: formData.dateType,
        });
    }
    /**
     * 서버 요청 데이터 생성
     */
    createReqBody() {
        return {
            hubCode: this.selectedHubId,
            storeId: this.selectedStoreId,
            date: this.date,
            dateType: this.dateType,
        };
    }
}
